/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryExecutionOptions } from '../../models/query-execution-options';
import { QueryResultDto } from '../../models/query-result-dto';

export interface QueryExecutionDashboardsDashboardIdPost$Json$Params {
  dashboardId: string;
      body?: QueryExecutionOptions
}

export function queryExecutionDashboardsDashboardIdPost$Json(http: HttpClient, rootUrl: string, params: QueryExecutionDashboardsDashboardIdPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryResultDto>>> {
  const rb = new RequestBuilder(rootUrl, queryExecutionDashboardsDashboardIdPost$Json.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QueryResultDto>>;
    })
  );
}

queryExecutionDashboardsDashboardIdPost$Json.PATH = '/query-execution/dashboards/{dashboardId}';
